import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-start gap-4" }
const _hoisted_2 = { class: "flex-1 space-y-3" }
const _hoisted_3 = {
  key: 0,
  class: "mt-5 grid grid-cols-2 gap-3"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-5 space-y-2"
}
const _hoisted_5 = { class: "p-4 border-b border-slate-200/60 dark:border-slate-700/60" }
const _hoisted_6 = { class: "p-4 space-y-3" }
const _hoisted_7 = { class: "flex items-center justify-between gap-4" }
const _hoisted_8 = { class: "space-y-2 w-full" }
const _hoisted_9 = { class: "flex gap-2 shrink-0" }
const _hoisted_10 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }

import { computed } from 'vue'

type Variant = 'block' | 'text' | 'card' | 'table' | 'page'


export default /*@__PURE__*/_defineComponent({
  __name: 'Skeleton',
  props: {
    variant: { default: 'block' },
    w: { default: 'w-full' },
    h: { default: 'h-4' },
    lines: { default: 3 },
    avatar: { type: Boolean, default: false },
    stats: { type: Boolean, default: false },
    extraLines: { default: 0 },
    rows: { default: 6 },
    cols: { default: 6 },
    className: { default: '' }
  },
  setup(__props: any) {

const props = __props

const baseBg = computed(() => 'bg-slate-200/80 dark:bg-slate-700/50')

const wClass = computed(() => props.w || 'w-full')
const hClass = computed(() => props.h || 'h-4')

const lineWidthClass = (i: number) => {
  if (i === props.lines) return 'w-2/3'
  if (i % 3 === 0) return 'w-3/4'
  return 'w-full'
}

const colWidthClass = (c: number) => {
  // Make columns look “natural”
  if (c === 1) return 'col-span-3'
  if (c === 2) return 'col-span-2'
  if (c === props.cols) return 'col-span-1'
  return 'col-span-2'
}

return (_ctx: any,_cache: any) => {
  return (__props.variant === 'block')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      'animate-pulse rounded-xl',
      baseBg.value,
      wClass.value,
      hClass.value,
      __props.className,
    ]),
        "aria-busy": "true",
        "aria-live": "polite"
      }, null, 2))
    : (__props.variant === 'text')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['space-y-2', __props.className]),
          "aria-busy": "true"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lines, (i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass([
        'animate-pulse rounded-lg',
        baseBg.value,
        'h-3',
        lineWidthClass(i),
      ])
            }, null, 2))
          }), 128))
        ], 2))
      : (__props.variant === 'card')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass([
      'rounded-2xl border border-slate-200/60 dark:border-slate-700/60',
      'bg-white/70 dark:bg-slate-900/20 backdrop-blur-sm',
      'p-5 shadow-sm',
      __props.className,
    ]),
            "aria-busy": "true"
          }, [
            _createElementVNode("div", _hoisted_1, [
              (__props.avatar)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['animate-pulse rounded-xl', baseBg.value, 'h-12 w-12 shrink-0'])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(['animate-pulse rounded-lg', baseBg.value, 'h-4 w-1/2'])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(['animate-pulse rounded-lg', baseBg.value, 'h-3 w-2/3'])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(['animate-pulse rounded-lg', baseBg.value, 'h-3 w-3/4'])
                }, null, 2)
              ])
            ]),
            (__props.stats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['animate-pulse rounded-xl', baseBg.value, 'h-10'])
                  }, null, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(['animate-pulse rounded-xl', baseBg.value, 'h-10'])
                  }, null, 2)
                ]))
              : _createCommentVNode("", true),
            (__props.extraLines > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.extraLines, (i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass(['animate-pulse rounded-lg', baseBg.value, 'h-3', i === __props.extraLines ? 'w-2/3' : 'w-full'])
                    }, null, 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : (__props.variant === 'table')
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass([
      'rounded-2xl border border-slate-200/60 dark:border-slate-700/60',
      'bg-white/70 dark:bg-slate-900/20 backdrop-blur-sm',
      'overflow-hidden',
      __props.className,
    ]),
              "aria-busy": "true"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(['animate-pulse rounded-lg', baseBg.value, 'h-4 w-1/3'])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (r) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: r,
                    class: "grid grid-cols-12 gap-3 items-center"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cols, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c,
                        class: _normalizeClass([
            'animate-pulse rounded-lg',
            baseBg.value,
            'h-3',
            colWidthClass(c),
          ])
                      }, null, 2))
                    }), 128))
                  ]))
                }), 128))
              ])
            ], 2))
          : (__props.variant === 'page')
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass(['space-y-6', __props.className]),
                "aria-busy": "true"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['animate-pulse rounded-xl', baseBg.value, 'h-7 w-1/3'])
                    }, null, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(['animate-pulse rounded-lg', baseBg.value, 'h-4 w-1/2'])
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['animate-pulse rounded-xl', baseBg.value, 'h-10 w-28'])
                    }, null, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(['animate-pulse rounded-xl', baseBg.value, 'h-10 w-28'])
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                    return _createElementVNode("div", {
                      key: i,
                      class: _normalizeClass(['animate-pulse rounded-2xl', baseBg.value, 'h-24'])
                    }, null, 2)
                  }), 64))
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(['animate-pulse rounded-2xl', baseBg.value, 'h-72'])
                }, null, 2)
              ], 2))
            : _createCommentVNode("", true)
}
}

})